<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Card di contenimento della pagina -->
    <b-card title="Cos'è Loyalty & Incentive?" class="mr-1 ml-1">
      <b-card no-body class='mb-2 p-2'>
        <b-row class="line odd_line">
          <b-col sm>
            <h2 class='mt-5'><i><b>Il servizio Welfarebit Loyalty & Incentive, come funziona?</b></i></h2>
            <p class='infotext'>
              Se hai necessità di omaggiare un collaboratore a partita IVA, un cliente<br>
              importante o un partner di rilievo, ecco a vostra disposizione...<br>
              il <b>Servizio Welfarebit Loyalty & Incentive!</b>
            </p>
          </b-col>
          <b-col sm class="text-center">
            <b-img fluid rounded :src="info_img_01" alt="info_img_01" class="images"></b-img>
          </b-col>
        </b-row>
        <b-row class='mt-2 line even_line'>
          <b-col sm class="text-center">
            <b-img fluid rounded :src="info_img_02" alt="info_img_02" class="images"></b-img>
          </b-col>
          <b-col sm>
            <p class='infotext'>
              Secondo la normativa, più precisamente il <b-link href="https://www.agenziaentrate.gov.it/portale/documents/20143/371545/DLgs+175+21112014_Decreto+legislativo+del+21_11_2014+n.+175+-+.pdf/63c184dd-1ac3-bae5-3cca-d563b6b5e24b" target="_blank"><b>Decreto Legislativo 175/2014</b></b-link>,
              l'insieme di beni non rientranti nell'attività aziendale che è possibile erogare nei confronti di determinati portatori di interessi verso l'azienda è <b>deducibile sino a 50€ per singolo omaggio</b>.
            </p>
            <p class='infotext'>
              Per tagli superiori a 50€ per singolo omaggio si invita il cliente ad approfondire la normativa vigente o a richiedere una 
              consulenza ad un professionista
            </p>
          </b-col>
        </b-row>
        <b-row class='mt-2 line odd_line'>
          <b-col>
            <p class='infotext'>
              Tramite <b>Loyalty & Incentive</b>, Welfarebit apre la presente sezione ad un referente indicato dall'azienda che, così,
              potrà accantonare un determinato ammontare di credito ad un portafoglio virtuale da <b>destinare a soggetti terzi</b>.<br>
              Questi ultimi, quindi, potranno impiegare il suddetto credito come meglio desiderano, spendendolo per ottenere
              <b>buoni spesa, carburante, e-commerce e tanto ancora!</b>
            </p>
            <p class='infotext'>
              Ecco alcuni esempi tra gli <b>oltre 150 marchi:</b>
            </p>
          </b-col>
          <b-col sm class="text-center">
            <b-img fluid rounded :src="info_img_03" alt="info_img_03" class="brands"></b-img>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center mt-3">
            <h2>
                Vuoi saperne di più? <b-link target="_blank" href="https://userportal.welfarebit.it/media/docs/presentazione_incentive.pdf" class="brochure-link"><i>Scarica la nostra brochure!</i></b-link>
            </h2>
          </b-col>
        </b-row>
      </b-card>
    </b-card>

  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'

export default {
  name: 'IncentiveInfo',
  data() {
    return {
      // Variabili di base della pagina
      tagline_elem : [ { text : "Scopri Loyalty & Incentive", link: "office-incentive-info" } ],

      // Le immagini da integrare nella pagina
      info_img_01 : require('@/assets/incentive/incentive_img01.jpg'),
      info_img_02 : require('@/assets/incentive/incentive_img02.jpg'),
      info_img_03 : require('@/assets/incentive/incentive_img03.jpg')

    };
  },
  components: {
    PageTagline,
    SwitcherAziende
  }
}
</script>

<style scoped>
.infotext {
  font-size: 1.7em;
  padding-top: 1.6em;
}

@media (max-width: 768px) {
  .infotext {
    font-size: 1.4em;
    margin-top: 10px;
    padding-top: 0px;
  }
}

.images {
  margin-top: 15px;
  margin-bottom: 15px;
}
.brands {
padding-top:3.5em;
}

@media (max-width: 768px) and (orientation: portrait) {
  .images {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .brands {
    padding-bottom: 2.5em;
    padding-top: 0em;
  }
}


.line {
  margin-left: -7px;
  margin-right: -7px;
  border-radius: 15px;
}

.odd_line {
  background-color: #a3c7e0;
}

.even_line {
  background-color: #6a9dd7;
}

.brochure-link {
  text-decoration: none;
}

.brochure-link:hover {
  text-decoration: none;
}

</style>
